var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9257 21.1422L16.7835 14L23.9257 6.85782C24.6968 6.08673 24.6968 4.84532 23.9257 4.07423C23.1546 3.30314 21.9132 3.30314 21.1421 4.07423L14 11.2164L6.85776 4.07423C6.08667 3.30314 4.84526 3.30314 4.07417 4.07423C3.30308 4.84532 3.30308 6.08673 4.07417 6.85782L11.2164 14L4.07417 21.1422C3.30308 21.9133 3.30308 23.1547 4.07417 23.9258C4.84526 24.6969 6.08667 24.6969 6.85776 23.9258L14 16.7836L21.1421 23.9258C21.9132 24.6969 23.1546 24.6969 23.9257 23.9258C24.6914 23.1547 24.6914 21.9078 23.9257 21.1422Z",
    fill: "#FFC700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.8ab571de4c8416a7f9d856aaf91af73d.svg";
export { ForwardRef as ReactComponent };